import React, { Component } from 'react';

import ProjectContent from '../../../components/ProjectContent';
import '../../../css/views/project.css';

export default class Fairytics extends Component {
	render() {
		 return (
			 <div>
				 <ProjectContent altTitle="Comment fonctionne Fairytics">
					<p className="text-detail">
					Fairytics repose sur un dispositif terrain constitué d’une application mobile et des balises Beacons d’un côté et d’une plateforme d’administration online de l’autre.
					</p>
					<p className="text-detail">
					1. Le beacon envoie un signal bluetooth.

					</p>
					<p className="text-detail">2. La plateforme Fairytics dans laquelle le contenu a été administré, analyse les données et produit une information personnalisée pour l'utilisateur.
</p>
					<p className="text-detail">3. L'application installée sur le mobile du client reçoit l'information.</p>
					<p className="text-detail">Fairytics est l’outil parfait pour optimiser votre activité.
					Pour en savoir plus <a href="https://fairytics.fr">c'est ici</a>!
</p>
				 </ProjectContent>
			 </div>
		 )
	}
}


// WEBPACK FOOTER //
// ./src/views/projet/fiches/Fairytics.js